/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Maintainer_P1Inputs */

const en_contact_maintainer_p1 = /** @type {(inputs: Contact_Maintainer_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON is not an anonymous ad page. Here is who is responsible for it and where you can verify that.`)
};

const ko_contact_maintainer_p1 = /** @type {(inputs: Contact_Maintainer_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 익명 광고 페이지가 아닙니다. 누가 책임지고 있으며 어디서 확인할 수 있는지 아래에 밝힙니다.`)
};

const ja_contact_maintainer_p1 = /** @type {(inputs: Contact_Maintainer_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON は匿名の広告ページではありません。誰が責任を持っているか、どこで確認できるかを以下に示します。`)
};

/**
* | output |
* | --- |
* | "PureJSON is not an anonymous ad page. Here is who is responsible for it and where you can verify that." |
*
* @param {Contact_Maintainer_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_maintainer_p1 = /** @type {((inputs?: Contact_Maintainer_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Maintainer_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_maintainer_p1(inputs)
	if (locale === "ko") return ko_contact_maintainer_p1(inputs)
	return ja_contact_maintainer_p1(inputs)
});